/**
 * Admin Communications Page — OpenPhone hub + Inbox Plateforme
 */
import React, { useState } from "react";
import { RequireRole } from "@/lib/useUser";
import { CommunicationsApp } from "@/pages/staff/Communications";
import AdminInbox from "@/components/shared/AdminInbox";
import { Phone, Inbox } from "lucide-react";

type Tab = "comms" | "inbox";

export default function AdminCommunications() {
  const [activeTab, setActiveTab] = useState<Tab>("comms");

  const tabs: { id: Tab; label: string; icon: React.ElementType }[] = [
    { id: "comms", label: "Communications",   icon: Phone  },
    { id: "inbox", label: "Inbox Plateforme", icon: Inbox  },
  ];

  return (
    <RequireRole allowed={["admin", "staff"]}>
      <div>
        {/* Tab bar */}
        <div className="flex items-center bg-muted/50 rounded-lg p-1 gap-1 mb-4 w-fit">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
                activeTab === tab.id
                  ? "bg-background text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              <tab.icon className="w-3.5 h-3.5" />
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === "comms" && <CommunicationsApp />}
        {activeTab === "inbox" && <AdminInbox />}
      </div>
    </RequireRole>
  );
}